import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import MenuPage from "./pages/MenuPage";
import AboutPage from "./pages/AboutPage";
import BookingPage from "./pages/BookingPage";
import OrderPage from "./pages/OrderPage";
import CartPage from "./pages/CartPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ContactPage from "./pages/ContactPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import OrderConfirmationPage from "./pages/OrderConfirmationPage";
import ManageBookingPage from "./pages/ManageBookingPage";
import AccountPage from "./pages/AccountPage";
import TableCalendarPage from "./pages/TableCalendarPage";
import QRMenuPage from "./pages/QRMenuPage";
import QRCodePage from "./pages/QRCodePage";
import AdminPage from "./pages/AdminPage";
import "./App.css";

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollToTop />
        {/* Tawk.to Live Chat Widget is loaded directly in public/index.html */}
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#1a1a1a',
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.1)',
            },
          }}
        />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/order" element={<OrderPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
            <Route path="/manage-booking/:token" element={<ManageBookingPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/availability" element={<TableCalendarPage />} />
          </Route>
          {/* QR Menu - Standalone page without navbar/footer */}
          <Route path="/menu-qr" element={<QRMenuPage />} />
          {/* QR Code Download Page */}
          <Route path="/qr-code" element={<QRCodePage />} />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
